export function vld_googlerecaptcha(val, el) {
	var field = $('#gvalidate').val();

	if ($('div.g-recaptcha').length === 0) {
		return true;
	}

	if (field != "1") {
		$(el).data('msg-custom', 'Please verify you are not a robot.');
		return false;
	} else {
		return true;
	}
}

export function ongvsuccess() {
	$('#gvalidate').val(1);
}

export function wireSharedGlobals(isDomainDetails) {
	//--shared between AP and Public
	$('.jdpicker').prop('autocomplete', "off").datepicker({
		autoHide: true,
		zIndex: 1070
	});

	Fancybox.bind('[data-fancybox]', {
		Toolbar: {
			display: [
				'close'
			]
		}
	});

	$('body').on('click', '.printbutton', function () {
		$('.printarea').printArea();
	});

	tinycfgfactory.initTinyMceUnobtrusive('[data-mnw-tmce]')

	$('[data-mnw-numeric],[data-mnw-currency]').each(function () {
		let $this = $(this);
		let negative = $this.data('mnw-numeric-allownegative') !== undefined;
		let decimal = $this.data('mnw-currency') !== undefined;

		$(this).numericOnly({allowDecimal: decimal, allowNegative: negative});
	});

	$('form[data-mnw-disable]').each(function () {
		$(this).disableOnSubmit();
	});

	$('a[data-mnw-href-delete]').each(function () {
		let $this = $(this);

		$this.on('click', function (e) {
			e.preventDefault();

			let href = $this.prop('href');
			let prompt = $this.data('mnw-href-delete');
			if (prompt === undefined || prompt === '')
				prompt = "Delete this Item?";

			alertify.customconfirm(prompt, function () {
				window.location = href;
			});
		});
	});

	$('textarea[maxlength],textarea[data-rule-maxlength]').restrictMaxLength();

	document.querySelectorAll('[data-mnw-toggle-display-block]').forEach(item => {
		let id = item.dataset.mnwToggleDisplayBlock;
		let el = document.getElementById(id);

		if (!el)
			return;

		item.addEventListener('click', function (ev) {
			if (el.style.display == 'none')
				el.style.display = 'block';
			else
				el.style.display = 'none';
		})
	});

	document.querySelectorAll('select[data-mnw-jumpmenu]').forEach(item => {
		item.addEventListener('change', function (ev) {
			if (item.value !== '')
				window.location = item.value;
		})
	});

	$('a.viewprofilelink').on("click", function (e) {
		let $this = $(this);
		let front = $this.data('public');

		if (front !== undefined)
			front = "1";
		else
			front = "0";

		WebUI.loadModal("/admin2/common/viewprofile/show_modal.php?", {
			'id': $(this).data('id'),
			'public': front
		}, 'View Profile');
		e.preventDefault();
	});

	if (isDomainDetails === undefined || isDomainDetails === false) {
		SharedScripts.CustomFormFieldLoader.init();
	}

	document.querySelectorAll('[data-mnw-copy-value]').forEach(item => {
		item.addEventListener('click', function (event) {
			event.preventDefault();
			const valueToCopy = item.dataset.mnwCopyValue;

			copyTextToClipboard(valueToCopy)
				.then(() => showCopiedFeedback(item, ' Copied', 'green'))
				.catch(err => {
					showCopiedFeedback(item, ' Copy Failed', 'red');
				});
		});
	});

	document.querySelectorAll('[data-mnw-copy-link-modal]').forEach(item => {
		let val = item.dataset.mnwCopyLinkModal;

		if (!val) {
			return;
		}

		item.addEventListener('click', function (ev) {
			ev.preventDefault();

			alertify.customalert("<input type='text' id='copyinput' class='naked-input' value='" + val + "' />" + "<div class='ca mnw-mt-10'><a href='#' class='mnw-btn-secondary' id='copyToClipBoardButton'>Copy to Clipboard</a></div>");

			const copyButton = document.querySelector('#copyToClipBoardButton');
			copyButton.addEventListener('click', (e) => {
				e.preventDefault();
				const input = document.querySelector('#copyinput');

				copyTextToClipboard(input.value)
					.then(() => showCopiedFeedback(copyButton, ' Copied', 'green'))
					.catch(err => {
						showCopiedFeedback(copyButton, ' Copy Failed', 'red');
					});
			});
		});
	});
}

export function copyTextToClipboard(text) {
	return new Promise((resolve, reject) => {
		if (window.isSecureContext && navigator.clipboard) {
			navigator.clipboard.writeText(text)
				.then(resolve)
				.catch(reject);
		} else {
			const textArea = document.createElement('textarea');
			textArea.value = text;
			textArea.style.position = 'fixed';
			textArea.style.top = '0px';
			textArea.style.left = '0px';
			textArea.style.width = '2em';
			textArea.style.height = '2em';
			textArea.style.padding = '0px';
			textArea.style.border = 'none';
			textArea.style.outline = 'none';
			textArea.style.boxShadow = 'none';
			textArea.style.background = 'transparent';

			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();

			try {
				document.execCommand('copy');
				resolve();
			} catch (err) {
				reject(err);
			}

			document.body.removeChild(textArea);
		}
	});
}

export function showCopiedFeedback(element, message, color) {
	if (element.nextElementSibling && element.nextElementSibling.dataset.copyFeedback) {
		return;
	}

	const feedbackElement = document.createElement('span');
	feedbackElement.dataset.copyFeedback = true;
	feedbackElement.textContent = message;
	feedbackElement.style.color = color;

	element.parentNode.insertBefore(feedbackElement, element.nextSibling);

	setTimeout(() => {
		if (feedbackElement.parentNode) {
			feedbackElement.parentNode.removeChild(feedbackElement);
		}
	}, 2000);
}